import { render } from "./OTIMeta.vue?vue&type=template&id=534aedf5"
import script from "./OTIMeta.vue?vue&type=script&lang=js"
export * from "./OTIMeta.vue?vue&type=script&lang=js"

import exportComponent from "/Users/frankreinshome/Development/otiplayer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__